import { TimezoneType } from "models/automation";
import { CalendarEvent } from "../types";
import WeekCalendar from "../WeekCalendar";

// Re-export types for easier importing
export type { CalendarEvent } from "../types";
export type { default as WeekCalendar } from "../WeekCalendar";

export default function Calendar({
  events,
  onUpdate,
  onCreate,
  onEventClick,
  startDate,
  timezone,
  showWeekends,
}: {
  events: CalendarEvent[];
  onUpdate: (eventId: string, newStart: Date, newEnd: Date) => void;
  onCreate: (start: Date, end: Date) => void;
  onEventClick?: (event: CalendarEvent) => void;
  startDate: Date; // beginning of week
  timezone: TimezoneType;
  showWeekends?: boolean;
}) {
  return (
    <WeekCalendar
      events={events}
      onUpdate={onUpdate}
      onCreate={onCreate}
      onEventClick={onEventClick}
      startDate={startDate}
      timezone={timezone}
      showWeekends={showWeekends}
      editable
    />
  );
}
